export default "__VITE_ASSET__YkXYkjur__"